
























































import { Component, Mixins, Prop } from "vue-property-decorator";
import UserManagementBtnMixin from "@/mixins/UserManagementBtnMixin";
import { UpdateRoleBodyI } from "@/models/admin/UserModel";
import { ACTION_CHANGE_ROLE } from "@/store/actions-types";
import { UserRoles } from "@/models/auth/AuthenticatedUser";
import RoleSelector from "@/components/user-management/RoleSelector.vue";

@Component({
  components: { RoleSelector },
})
/**
 * Adds a button and modal with a form to change a user's role assignment
 */
export default class ChangePasswordBtn extends Mixins(UserManagementBtnMixin) {
  /**
   * The username which will be updated
   */
  @Prop({ required: true }) readonly username!: string;

  /**
   * The current user role
   */
  @Prop({ required: false }) readonly role?: UserRoles;

  /**
   * current or new user role
   */
  public updatedRole: UserRoles | null = null;

  /**
   * set the current role
   */
  async mounted(): Promise<void> {
    if (this.role) {
      this.updatedRole = this.role;
    }
  }

  /**
   * check we actually set a new role
   */
  isNewRoleValid(): boolean {
    return this.role !== this.updatedRole;
  }

  /**
   * Change the role
   */
  async updateRole(): Promise<void> {
    if (!this.updatedRole) return;
    this.isLoading = true;
    const user: UpdateRoleBodyI = {
      username: this.username,
      role: this.updatedRole,
    };
    try {
      await this.$store.dispatch(ACTION_CHANGE_ROLE, user);
      this.modalShow = false;
      this.$emit("role-updated");
    } finally {
      this.isLoading = false;
    }
  }
}
